/*
 * © 2024 Snyk Limited
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sha1NotFoundError = exports.MavenSearchServiceUnavailableError = void 0;
const types_1 = require("../types");
const problem_error_1 = require("../problem-error");
/**
 * @class
 * @name MavenSearchServiceUnavailableError
 * @description The upstream Maven search service is not available.
 *
 * See more:
 * - [https://search.maven.org](https://search.maven.org)
 * - [https://status.maven.org](https://status.maven.org)
 * @summary Maven search service unavailable
 * @category OpenSourceUnmanaged
 * @param {string} details                         the specific details that causes this error
 * @param {Classification} classification          the error classification determining if the error is user-actionable or not
 * @param {Record<string, any>} [additionalData]   a collection of relevant data specific to this error
 * @param {Error} [cause]                          the `Error` type that caused this error to be thrown
 * @param {string} [instance]                      the instance to use for this error. Overrides 'instance' metadata
 */
class MavenSearchServiceUnavailableError extends problem_error_1.ProblemError {
    constructor(details, additionalData, cause, instance, logs) {
        super({
            title: 'Maven search service unavailable',
            type: 'https://docs.snyk.io/scan-with-snyk/error-catalog#snyk-osjvm-001',
            status: 503,
            errorCode: 'SNYK-OSJVM-001',
            level: 'warn',
            classification: types_1.Classification.UNEXPECTED,
            instance,
        }, details, Object.assign({ links: [
                'https://search.maven.org',
                'https://status.maven.org',
            ] }, additionalData), cause, logs);
        this.name = this.constructor.name;
    }
}
exports.MavenSearchServiceUnavailableError = MavenSearchServiceUnavailableError;
/**
 * @class
 * @name Sha1NotFoundError
 * @description Unable to find the coordinates for the provided SHA1. Please verify the data you are sending and try again.
 *
 * See more:
 * - [https://docs.snyk.io/snyk-cli/test-for-vulnerabilities/scan-all-unmanaged-jar-files](https://docs.snyk.io/snyk-cli/test-for-vulnerabilities/scan-all-unmanaged-jar-files)
 * @summary SHA1 not found
 * @category OpenSourceUnmanaged
 * @param {string} details                         the specific details that causes this error
 * @param {Classification} classification          the error classification determining if the error is user-actionable or not
 * @param {Record<string, any>} [additionalData]   a collection of relevant data specific to this error
 * @param {Error} [cause]                          the `Error` type that caused this error to be thrown
 * @param {string} [instance]                      the instance to use for this error. Overrides 'instance' metadata
 */
class Sha1NotFoundError extends problem_error_1.ProblemError {
    constructor(details, additionalData, cause, instance, logs) {
        super({
            title: 'SHA1 not found',
            type: 'https://docs.snyk.io/scan-with-snyk/error-catalog#snyk-osjvm-002',
            status: 404,
            errorCode: 'SNYK-OSJVM-002',
            level: 'warn',
            classification: types_1.Classification.ACTIONABLE,
            instance,
        }, details, Object.assign({ links: [
                'https://docs.snyk.io/snyk-cli/test-for-vulnerabilities/scan-all-unmanaged-jar-files',
            ] }, additionalData), cause, logs);
        this.name = this.constructor.name;
    }
}
exports.Sha1NotFoundError = Sha1NotFoundError;
//# sourceMappingURL=OpenSourceUnmanaged-error-catalog.js.map